<template>
    <div>
        <Breadcrumbs main="Admin" submain="Volunteer" title="Type" />
        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <button class="btn btn-primary" type="submit" v-b-modal.modal-prevent-closing style="display: flex; gap: 12px; align-items: center;">
                                <i class="fa fa-light fa-plus"></i>
                                <h7>Add New Type</h7>
                            </button>
                        </div>
    
                        <div class="card-body">
                            <b-row>
                                <b-col xl="6">
                                    <b-input-group class="datatable-btn">
                                        <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                        <b-input-group-append>
                                            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-col>
    
                                <b-col xl="6">
                                    <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                        <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                    </b-form-group>
                                </b-col>
                            </b-row>
    
                            <div v-if="!loading && !error">
                                <div class="table-responsive datatable-vue">
                                    <b-table show-empty stacked="md" :items="volunteer_type" :fields="tablefields" :filter="filter" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">
                                        <template #cell(index)="data">
                                            {{ (currentPage - 1) * perPage + data.index + 1 }}
                                        </template>
    
                                        <template #cell(name)="row">
                                            <div v-if="row.item.name">
                                                <p>{{ row.item.name }}</p>
                                            </div>
                                        </template>
    
                                        <template #cell(action)="data">
                                            <span style="display: flex; gap: 12px;">
                                                <div @click="editType(data.item)">
                                                    <feather type="edit" size="18px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="Edit" v-b-modal.modal-prevent-closing-edit></feather>
                                                </div>
                                                <div>
                                                    <feather type="delete" size="18px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteType(data.item.id)" title="Delete"></feather>
                                                </div>
                                            </span>
                                        </template>
                                    </b-table>
                                </div>
                            </div>
    
                            <div v-else>
                                <loader />
                            </div>
    
                            <b-col md="6" class="my-1 p-0">
                                <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                            </b-col>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Container-fluid Ends-->
    
        <!-- Type Create Modal -->
        <b-modal id="modal-prevent-closing" ref="modal" title="Add Type" size="md" @show="resetModal" @hidden="resetModal" @ok="handleOk">
            <form ref="form" @submit.stop.prevent="handleSubmit()">
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Type</label>
                            <input class="form-control" type="text" placeholder="Enter volunteer type" v-model="volunteer.name">
                        </div>
                    </div>
                </div>
            </form>
        </b-modal>
    
        <!-- Type Edit Modal -->
        <b-modal id="modal-prevent-closing-edit" ref="modal" title="Edit Type" size="md" @show="resetEditModal" @hidden="resetEditModal" @ok="handleEditOk">
            <form ref="form" @submit.stop.prevent="handleEditSubmit">
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Type</label>
                            <input class="form-control" type="text" placeholder="Enter volunteer type" v-model="edit_volunteer.name">
                        </div>
                    </div>
                </div>
            </form>
        </b-modal>
    
        <!-- Type Delete Modal -->
        <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
            <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this type?</div>
        </b-modal>
    </div>
    </template>
    
<script>
    import Swal from 'sweetalert2/dist/sweetalert2.js';
    import 'sweetalert2/src/sweetalert2.scss';
    import { mapState } from 'vuex';
    import { myHost } from '../../../_helpers/host';
    import loader from '../loader/loader.vue';
    
    export default {
        components: {
            loader
        },
    
        data() {
            return {
                host: myHost.host,
                tablefields: [
                    {
                        key: 'index',
                        label: '#'
                    },
                    {
                        key: 'name',
                        label: 'Name',
                        sortable: true
                    },
                    {
                        key: 'action',
                        label: 'Action',
                        sortable: false
                    }
                ],
    
                volunteer: {
                    name: ''
                },
    
                edit_volunteer: {
                    id: '',
                    name: ''
                },
    
                delete_value: null,
    
                filter: null,
                totalRows: 1,
                currentPage: 1,
                perPage: 10,
                pageOptions: [10, 15, 20]
            };
        },
    
        computed: {
            ...mapState({
                volunteer_type: state => state.volunteer.volunteerType,
                loading: state => state.volunteer.volunteerTypeLoading,
                error: state => state.volunteer.volunteerTypeError
            })
        },
    
        mounted() {
            this.$store.dispatch("volunteer/fetchType").then(() => { 
                this.items = this.volunteer_type
                this.totalRows = this.volunteer_type.length;
            });
        },
    
        methods: {
            onFiltered(filteredItems) {
                this.totalRows = filteredItems.length;
                this.currentPage = 1;
            },
    
            resetModal() {
                this.volunteer.name = null
            },
    
            handleOk(bvModalEvent) {
                bvModalEvent.preventDefault()
                this.handleSubmit()
            },
    
            handleSubmit() {
                this.$store.dispatch("volunteer/addType", {
                    volunteer: this.volunteer
                }).then(response => {
                    if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.response,
                            icon: "success"
                        });
                        this.volunteer.name = null
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.response,
                            icon: "error"
                        });
                    }
                })
    
                this.$nextTick(() => {
                    this.$bvModal.hide('modal-prevent-closing')
                })
            },
    
            editType(detail) {
                this.edit_volunteer.id = detail.id ? detail.id : null
                this.edit_volunteer.name = detail.name ? detail.name : null
            },
    
            resetEditModal() {
                this.edit_volunteer.name = null
            },
    
            handleEditOk(bvModalEvent) {
                bvModalEvent.preventDefault()
                this.handleEditSubmit()
            },
    
            handleEditSubmit() {
                this.$store.dispatch("volunteer/updateType", {
                    id: this.edit_volunteer.id,
                    volunteer: this.edit_volunteer
                }).then(response => {
                    if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.response,
                            icon: "success"
                        });
                        this.edit_volunteer.name = null
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.response,
                            icon: "error"
                        });
                    }
                })
    
                this.$nextTick(() => {
                    this.$bvModal.hide('modal-prevent-closing-edit')
                })
            },
    
            deleteType(id) {
                this.delete_value = id
            },
    
            handleDeleteOk() {
                this.$store.dispatch("volunteer/deleteType", {
                    delete: this.delete_value
                }).then(response => {
                    if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.response,
                            icon: "success"
                        });
                        this.delete_value = null
    
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.response,
                            icon: "error"
                        });
                    }
                })
            }
        }
    };
    </script>
    